function updateSideScroller() {
  jQuery(".side-scroll").each(function() {
    var scroller = jQuery(this);
    //setTimeout(function () {
    
    // If we're on desktop showing 3 items, just remove the class.
    if (scroller.attr('data-count') <= 3 && jQuery(document).width() > 768) { 
      //scroller.removeClass('side-scroll');
      //return;
    }


    var scroll_controls = scroller.find(".scroll-controls");
    var scroll_container = scroller.find(".container-fluid.scrollable");
    if (!scroll_container.length) {
      scroll_container = scroller.find(".container-fluid").first();
    }
    var leftPos = scroll_container.scrollLeft();

    //console.log(leftPos);

    // If we are all the way to left hide that arrow.
    if (leftPos <= 0) {
      scroll_controls.find("a.back").addClass("out disabled").attr("aria-disabled", "true");
    } else {
      scroll_controls.find("a.back").removeClass("out disabled").attr("aria-disabled", "false");
    }

    // Check if we're scrolled all the way to right?
    var viewable_width = scroll_container.innerWidth();
    var scrollable_width = scroll_container[0].scrollWidth;
    //console.log("Scrollable width is " + scrollable_width);
    //console.log("Viewable width " + viewable_width);
    //console.log("Left position is  " + leftPos);

    if (leftPos + viewable_width + 10 >= scrollable_width) {
      scroller.find("a.forward").addClass("out disabled").attr("aria-disabled", "true");
    } else {
      scroller.find("a.forward").removeClass("out disabled").attr("aria-disabled", "false");
    }
    //}, 210);
  });
}

// Testimonials scroll
jQuery(document).ready(function() {
  updateSideScroller();
  setTimeout(updateSideScroller, 250);
  jQuery(window).on("load", updateSideScroller);

  jQuery(".side-scroll .container-fluid").scroll(
    jQuery.throttle(65, updateSideScroller)
  );
  jQuery(".side-scroll a.forward").click(function() {
    if (jQuery(this).hasClass("disabled")) {
      return false;
    }

    var scroller = jQuery(this).closest(".side-scroll");
    var scroll_container = scroller.find(".container-fluid.scrollable");
    if (!scroll_container.length) {
      scroll_container = scroller.find(".container-fluid").first();
    }
    var leftPos = scroll_container.scrollLeft();

    // Get the size of the first div
    var first_div = scroll_container.find(".gallery-slider-item").first();
    if (!first_div.length) {
      first_div = scroll_container.find('div[class*="col-"]').first();
    }
    var scroll_distance = first_div.outerWidth(true) || scroll_container.innerWidth();

    scroll_container.animate(
      { scrollLeft: leftPos + scroll_distance },
      200,
      updateSideScroller
    );
    return false;
  });

  jQuery(".side-scroll a.back").click(function() {
    if (jQuery(this).hasClass("disabled")) {
      return false;
    }

    var scroller = jQuery(this).closest(".side-scroll");
    var scroll_container = scroller.find(".container-fluid.scrollable");
    if (!scroll_container.length) {
      scroll_container = scroller.find(".container-fluid").first();
    }
    var leftPos = scroll_container.scrollLeft();

    // Get the size of the first div
    var first_div = scroll_container.find(".gallery-slider-item").first();
    if (!first_div.length) {
      first_div = scroll_container.find('div[class*="col-"]').first();
    }
    var scroll_distance = first_div.outerWidth(true) || scroll_container.innerWidth();

    scroll_container.animate(
      { scrollLeft: leftPos - scroll_distance },
      200,
      updateSideScroller
    );
    return false;
  });
});

function getFeatherlightCaption(trigger) {
  var element = jQuery(trigger);
  var image = element.find("img").first();
  var caption =
    element.data("caption") ||
    image.attr("alt") ||
    image.attr("title") ||
    element.attr("title") ||
    element.attr("alt") ||
    "";

  return jQuery.trim(caption);
}

function updateFeatherlightCaption() {
  if (!this.$instance || !this.$currentTarget) {
    return;
  }

  var caption = getFeatherlightCaption(this.$currentTarget);
  var content = this.$instance.find(".featherlight-content");

  content.find(".featherlight-caption").remove();

  if (caption) {
    jQuery("<div />", {
      "class": "featherlight-caption",
      text: caption
    }).appendTo(content);
  }
}

function fitCompanyFeatherlightImage() {
  if (!jQuery("body").hasClass("single-companies") || !this.$instance) {
    return;
  }

  var content = this.$instance.find(".featherlight-content");
  var image = content.find(".featherlight-image").first();

  if (!image.length) {
    return;
  }

  var naturalWidth = image[0].naturalWidth || this.$content.naturalWidth;
  var naturalHeight = image[0].naturalHeight || this.$content.naturalHeight;

  if (!naturalWidth || !naturalHeight) {
    return;
  }

  var numberValue = function(value) {
    return parseFloat(value) || 0;
  };
  var horizontalChrome =
    numberValue(content.css("padding-left")) +
    numberValue(content.css("padding-right")) +
    numberValue(content.css("border-left-width")) +
    numberValue(content.css("border-right-width"));
  var verticalChrome =
    numberValue(content.css("padding-top")) +
    numberValue(content.css("padding-bottom")) +
    numberValue(content.css("border-top-width")) +
    numberValue(content.css("border-bottom-width"));
  var maxContentWidth = Math.min(jQuery(window).width() - 40, jQuery(window).width() * 0.9);
  var maxContentHeight = Math.min(jQuery(window).height() - 40, jQuery(window).height() * 0.95);
  var maxImageWidth = Math.max(1, maxContentWidth - horizontalChrome);
  var scale = Math.min(1, maxImageWidth / naturalWidth);

  // Recalculate a few times because a narrower image can make the caption wrap
  // onto additional lines and reduce the remaining image height.
  for (var i = 0; i < 4; i++) {
    var imageWidth = Math.floor(naturalWidth * scale);
    var imageHeight = Math.floor(naturalHeight * scale);

    content.css("width", Math.ceil(imageWidth + horizontalChrome) + "px");
    image.css({
      width: imageWidth + "px",
      height: imageHeight + "px"
    });

    var captionHeight = content.find(".featherlight-caption").outerHeight(true) || 0;
    var maxImageHeight = Math.max(1, maxContentHeight - verticalChrome - captionHeight);
    var nextScale = Math.min(1, maxImageWidth / naturalWidth, maxImageHeight / naturalHeight);

    if (Math.abs(nextScale - scale) < 0.001) {
      break;
    }

    scale = nextScale;
  }
}

function initFlexibleContentGalleries() {
  if (!jQuery.fn.featherlightGallery) {
    return;
  }

  jQuery("[data-gallery-lightbox]").each(function() {
    var gallery = jQuery(this);

    if (gallery.data("gallery-lightbox-ready")) {
      return;
    }

    // Remove Featherlight's broad auto-binding from older cached markup. It
    // includes the slider controls in the slides and also binds the gallery twice.
    gallery
      .off("click.featherlight")
      .removeAttr("data-featherlight-gallery")
      .removeAttr("data-featherlight-filter");

    gallery.data("gallery-lightbox-ready", true);
    gallery.featherlightGallery({
      filter: "a.gallery"
    });
  });
}

jQuery(document).ready(function() {
  if (jQuery.featherlight) {
    var featherlightAfterContent = jQuery.featherlight.defaults.afterContent;
    var featherlightOnResize = jQuery.featherlight.defaults.onResize;
    jQuery.featherlight.defaults.afterContent = function(event) {
      featherlightAfterContent.call(this, event);
      updateFeatherlightCaption.call(this);
    };
    jQuery.featherlight.defaults.onResize = function(event) {
      featherlightOnResize.call(this, event);
      fitCompanyFeatherlightImage.call(this);
    };
  }

  if (jQuery.featherlightGallery) {
    var featherlightGalleryAfterContent = jQuery.featherlightGallery.defaults.afterContent;
    var featherlightGalleryOnResize = jQuery.featherlightGallery.defaults.onResize;
    jQuery.featherlightGallery.defaults.afterContent = function(event) {
      featherlightGalleryAfterContent.call(this, event);
      updateFeatherlightCaption.call(this);
    };
    jQuery.featherlightGallery.defaults.onResize = function(event) {
      featherlightGalleryOnResize.call(this, event);
      fitCompanyFeatherlightImage.call(this);
    };
  }

  initFlexibleContentGalleries();
});
